// Module
var code = "<div class=\"{{class}}\" id=\"{{id}}\"> <div class=\"shopping-cart\"> <div class=\"ready-to-checkout\"></div> <div class=\"request-quotation\"></div> </div> </div>";
// Exports
module.exports = code;